<template>
	<section>
		<div class="d-sm-flex align-items-center justify-content-between mb-4">
	        <h1 class="h3 mb-0 text-gray-800">Monitor e captura de áudio DDR</h1>

			<div>
				<pdfBtn 
					:filter="string_filter" 
					type="datatable" 
					title="interceptação de ramal"
					datatable="Ramal"
                    :external="true"
					:data_head="data_head" 
					:data_body="data_body" 
				/>
			</div>
	    </div>

	    <filtros :filter_data="filter_data" @filtrar="filtrar" />

		<table class="table table-striped table-sm">
    		<thead align="center">
    			<th @click="orderBy('ID')"        >ID       <font-awesome-icon v-if="direction.by == 'ID'"        :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('EXTENSION')" >RAMAL    <font-awesome-icon v-if="direction.by == 'EXTENSION'" :icon="order_icon" size="xs" /></th>
				<th @click="orderBy('STATUS')" >STATUS    <font-awesome-icon v-if="direction.by == 'STATUS'" :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('NAME')"      >OPERADOR <font-awesome-icon v-if="direction.by == 'NAME'"      :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('PARENT_ID')" >{{view_nome.setor_nome}}    <font-awesome-icon v-if="direction.by == 'PARENT_ID'" :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('RECORD')"    >GRAVAÇÃO <font-awesome-icon v-if="direction.by == 'RECORD'"    :icon="order_icon" size="xs" /></th>
    			<th>
    				<font-awesome-icon @click="toggle_record_all(1)" icon="microphone" title="Ativar gravação para todos!" class="vermelho" />
    				<small> - </small>
    				<font-awesome-icon @click="toggle_record_all(0)" icon="microphone-slash" title="Desativar gravação para todos!" />
    			</th>
    		</thead>

			<transition mode="out-in" name="leftIn">
	    		<tbody v-if="ramais" align="center">
	    			<tr v-for="(ramal, index) in ramais.result.data" :key="index">
						<td>{{ ramal.ID }}</td>
						<td>{{ ramal.EXTENSION }}</td>
						<td><font-awesome-icon v-if="ramal.STATUS == 1" icon="phone" size="xs" style="color: red" />
							<font-awesome-icon v-else icon="phone" size="xs" style="color: green" /></td>
						<td>{{ ramal.NAME }}</td>
						<td>{{ get_setor_name(ramal.PARENT_ID) }}</td>

						<td><font-awesome-icon @click="toggle_record(ramal)" class="pointer" :icon="(ramal.RECORD == 1) ? 'microphone' : 'microphone-slash'" :title="(ramal.RECORD == 1) ? 'Desativar gravação' : 'Ativar gravação'" :class="(ramal.RECORD == 1) ? 'vermelho' : ''" /></td>

						<td>
							<router-link :to="{name: 'RamalView', params: { get: ramal.ID, ramal: ramal} }">
								<font-awesome-icon icon="eye" class="info pointer"/>
							</router-link>
						</td>
					</tr>

	    		</tbody>
	    		<div v-else><Loading/></div>
	    	</transition>
    	</table>
		
    	<controls  :data="constrol_data" @refresh="navigate"  @alert="show_alert" />
	</section>
</template>

<script>
	import api      from "@/mixins/api.js"
	import replace  from "@/mixins/replace.js"
	import pdfBtn   from "@/components/Tools/Pdf.vue"
	import filtros  from "@/components/Tools/Filtro.vue"
	import controls from "@/components/Tools/Table_Control.vue"

	export default {
		name: "Ramais",
		props: ["table", "method"],
		mixins: [api],
		components: { controls, filtros, pdfBtn },

		data() { return {
			ramais: null,
			constrol_data: {},
			setores: { status:null, result:null },
			looping: null,
			timestamps: true,

			direction: { order: "asc", by: "ID" },

			pagination: "10?",
			string_filter: "",

			filter_data: [
				{ name: "ID",        label: "ID",       type: "text",   data_get: ""},
				{ name: "NAME",      label: "Oparador", type: "text",   data_get: ""},
				{ name: "EXTENSION", label: "Ramal",  	type: "text",   data_get: ""},
				{ name: "PARENT_ID", label: "Setor",    type: "select", data_get: "Setor"},
			],
			data_head: ["ID", "RAMAL", "OPERADOR", "SETOR", "GRAVAÇÃO"],
			data_body: ["ID", "EXTENSION", "NAME", "setor", "record"]
		}},

		created() {
			this.get_setores()
			this.get_data();
		},

		computed: {
			ordenation() {
				return `order=${this.direction.order}&by=${this.direction.by}`
			},

			order_icon() {
				return ( this.direction.order == "asc" ) ? "arrow-up" : "arrow-down"
			},
			
			view_nome(){ return this.$store.state.config_view_menu },
		},

		methods: {
			async toggle_record_all(payload) {
				const response = await this.POST("Ramal/Toggle", { "RECORD" : payload })
				this.get_data()
			},

			async toggle_record(payload) {
				payload.RECORD = ( payload.RECORD == 1 ) ? 0 : 1
				const response = await this.PUT('Ramal', payload)
			},

			async get_setores() {
				this.setores = await this.GET("Setor")
			},

			get_setor_name(payload) {
				for (var i = 0; i <= this.setores.result.length -1; i++) {
					if ( this.setores.result[i].ID == payload){
						return this.setores.result[i].NAME
					}
				}
			},

			orderBy(payload) {
				if ( payload == this.direction.by ) {
					this.direction.order = ( this.direction.order == 'desc' ) ? 'asc' : 'desc'
				}

				else this.direction.by = payload

				this.get_data()
			},

			filtrar(payload) {
				this.string_filter = payload
				this.get_data()
			},

			async get_data() {
				this.ramais = null
				this.ramais = await this.GET("Ramal", `Paginate/${this.pagination}${this.ordenation}${this.string_filter}`)

				this.constrol_data = {
					current_page: this.ramais.result.current_page,
					last_page:    this.ramais.result.last_page,
					per_page:     this.ramais.result.per_page,
					total:        this.ramais.result.total,
				}

				
				this.verifica_ocupado()
			},

			async verifica_ocupado(){
				const aux_ramais = this.ramais.result.data
				
				for(var chave=0, valor; valor=aux_ramais[chave], chave<aux_ramais.length; chave++) {
					var id_ramal = valor.ID
					const response = await this.GET('Ramal', id_ramal)
					valor.STATUS = response.result.STATUS
				}

				if (this.timestamps) this.refresh()
				else clearTimeout(this.looping)
			},

			refresh() {
                clearTimeout(this.looping)
                this.looping = setTimeout( () => this.verifica_ocupado(), 8000)
			},

			navigate(payload) {
				this.pagination = payload
				this.get_data()
			},

			show_alert(payload) {
				$("#modal-cadastro-ramal").modal('hide')
				this.get_data()

				this.$emit('alert', payload)
			},

			get_record_status(payload) {
				return ( payload == 1 ) ? "Gravando" : ""
			},
		}
	};
</script>

<style>
	
</style>